package com.milta.core.localization.translations.sq

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Rifresko",
    expandedStopsTitle = "Ndalesat",
    stopStatusWaitingLabel = "Në pritje",
    stopStatusFailedLabel = "Pa dorëzuar",
)
